(function () {
    'use script';

    angular
        .module(app.modules.common.name)
        .constant('siteType', createSiteType());

    function createSiteType() {
        return angular.createEnum({
            'default': 389
            , 'ushandicap': 226
            , 'montana': 265
            , 'maryland': 278
            , 'florida': 330
            , 'mbwa': 321

        });
    };
})();